// export type MealyModelType = ('DoorSystem' | 'Kara' | 'Kunstautomat' | 'AmpelSystem');
export var MealyModelType;
(function (MealyModelType) {
    MealyModelType["DOORSYSTEM"] = "DoorSystem";
    MealyModelType["KARA"] = "Kara";
    MealyModelType["KUNSTAUTOMAT1"] = "Kunstautomat1";
    MealyModelType["KUNSTAUTOMAT2"] = "Kunstautomat2";
    MealyModelType["AMPELSYSTEM"] = "AmpelSystem";
    MealyModelType["GARAGENTOR"] = "Garagentor";
    MealyModelType["CODESCHLOSS"] = "Codeschloss";
    MealyModelType["STOPPUHR"] = "Stoppuhr";
})(MealyModelType || (MealyModelType = {}));
;
// function identity<T>(x: T): T {
//     return x;
// }
// export function mealyModel_getOnStopExecute(mealyModelType: MealyModelType) {
//     switch (mealyModelType) {
//         case MealyModelType.DOORSYSTEM:
//             return identity;
//         case MealyModelType.KARA:
//             return identity;
//         case MealyModelType.KUNSTAUTOMAT:
//             return identity;
//         case MealyModelType.AMPELSYSTEM:
//             return ampelSystem_onStopExecution;
//     }
// }
// export function mealyModel_getOnTransition(mealyModelType: MealyModelType) {
//     switch (mealyModelType) {
//         case MealyModelType.DOORSYSTEM:
//             return identity;
//         case MealyModelType.KARA:
//             return identity;
//         case MealyModelType.KUNSTAUTOMAT:
//             return identity;
//         case MealyModelType.AMPELSYSTEM:
//             return ampelSystem_onTransition
//     }
// }
